import { render, staticRenderFns } from "./StepHeader.vue?vue&type=template&id=08e74a3e&"
import script from "./StepHeader.vue?vue&type=script&lang=js&"
export * from "./StepHeader.vue?vue&type=script&lang=js&"
import style0 from "./StepHeader.vue?vue&type=style&index=0&id=08e74a3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports